module.exports = __webpack_public_path__ + "static/media/CL 5.b486c319.mp3";